import React, { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { EuiLoadingContent } from '@elastic/eui'

import { useGetAccountsQuery } from 'api/rtkQueryApi/platform/accountsApi'
import { useGetMasterCampaignPlanQuery } from 'api/rtkQueryApi/platform/masterCampaignPlansApi'
import { showSuccessToast, updateAccount, updateAccountState } from 'app/appSlice'
import { RootState } from 'app/rootReducer'
import { useIsAgency } from 'whiteLabel/useIsAgency'

import { MasterCampaignPlanPageOld } from '../../old-pages/MasterCampaignPlanPage/MasterCampaignPlanPageOld'
import MasterCampaignPlanPage from './MasterCampaignPlanPage'

interface MasterCampaignPlanPageParams {
  masterCampaignPlanId: string
}

const MasterCampaignPlanPageDynamic: FC = () => {
  const dispatch = useDispatch()
  const isAgency = useIsAgency()
  const { currentAccount } = useSelector((state: RootState) => state.app)
  const { masterCampaignPlanId } = useParams<MasterCampaignPlanPageParams>()

  const { data: accounts } = useGetAccountsQuery({ isAgency: isAgency })
  const { data: masterCampaignPlan, isFetching, isLoading } = useGetMasterCampaignPlanQuery({ masterCampaignPlanId: masterCampaignPlanId }, { skip: !masterCampaignPlanId })

  useEffect(() => {
    if (!masterCampaignPlan || !currentAccount || !accounts) {
      return
    }

    if (masterCampaignPlan.accountId !== currentAccount.id) {
      const account = accounts?.find(a => a.id === masterCampaignPlan.accountId)
      if (account) {
        dispatch(updateAccountState(account))
        dispatch(showSuccessToast(`Switch account to ${account.name}`))
      }
    }
  }, [masterCampaignPlan, currentAccount, accounts])

  if (isLoading || (!masterCampaignPlan && isFetching)) {
    return <EuiLoadingContent lines={10} />
  }

  if (!currentAccount || !masterCampaignPlan || currentAccount.id !== masterCampaignPlan.accountId) {
    return <EuiLoadingContent lines={10} />
  }

  const hasPersonas = masterCampaignPlan.personas && masterCampaignPlan.personas.length > 0

  return hasPersonas ? <MasterCampaignPlanPage /> : <MasterCampaignPlanPageOld />
}

export default MasterCampaignPlanPageDynamic
